export default () => (
  <svg width="24" height="23" viewBox="0 0 24 23" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 5H0V21.5C0 22.328 0.672 23 1.5 23H22.5C23.329 23 24 22.328 24 21.5V6.5C24 5.672 23.329 5 22.5 5ZM1.5 2H7.5V3.5H9V2C9 1.172 8.329 0.5 7.5 0.5H1.5C0.672 0.5 0 1.172 0 2V3.5H1.5V2Z"
    />
  </svg>
)
